"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RadioGroup = void 0;

var _preact = require("preact");

var RadioGroup = function RadioGroup(_ref) {
  var children = _ref.children,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? 'vertical' : _ref$direction,
      _ref$spacing = _ref.spacing,
      spacing = _ref$spacing === void 0 ? 'M' : _ref$spacing;
  return (0, _preact.h)("div", {
    className: " m-radio-".concat(direction, " m-radio_spacing-").concat(spacing)
  }, children);
};

exports.RadioGroup = RadioGroup;

var Radio = function Radio(_ref2) {
  var value = _ref2.value,
      name = _ref2.name,
      id = _ref2.id,
      isChecked = _ref2.isChecked,
      onChange = _ref2.onChange,
      onClick = _ref2.onClick,
      _ref2$inputPosition = _ref2.inputPosition,
      inputPosition = _ref2$inputPosition === void 0 ? 'left' : _ref2$inputPosition,
      _ref2$showLabel = _ref2.showLabel,
      showLabel = _ref2$showLabel === void 0 ? true : _ref2$showLabel;
  return (0, _preact.h)("div", {
    className: "c-radio c-radio_position-".concat(inputPosition)
  }, (0, _preact.h)("input", {
    type: "radio",
    id: id,
    name: name,
    checked: isChecked,
    onChange: onChange,
    value: id,
    onClick: onClick
  }), showLabel ? (0, _preact.h)("label", {
    htmlFor: id
  }, value) : (0, _preact.h)("div", {
    className: "radio-text"
  }, value));
};

var _default = Radio;
exports.default = _default;